import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import _isNumber from "lodash/isNumber";
import _isObject from "lodash/isObject";
import "core-js/modules/es.array.map.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useContainerQuery } from 'react-container-query';
import { MastheadSmallCard } from "../../Card/MastheadSmallCard/MastheadSmallCard";
import { Grid } from "../Grid/Grid";
import { Responsive } from "../../Responsive/Responsive/Responsive";
import styles from "./MastheadCardGrid.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var MastheadCardGrid = function MastheadCardGrid(_ref) {
  var cardList = _ref.cardList,
    gridAlignment = _ref.gridAlignment;
  var query = {
    medium: {
      minWidth: 428,
      maxWidth: 669
    },
    large: {
      minWidth: 670
    }
  };
  var getColumnCount = function getColumnCount(cardList) {
    if (cardList && cardList.length) {
      var cardsCount = cardList.length;
      return cardsCount <= 4 ? 4 : cardsCount / 2;
    }
    return 0;
  };
  var config = {
    default: {
      smallCard: {
        columnsCount: 2,
        size: 'default'
      }
    },
    medium: {
      smallCard: {
        columnsCount: 2,
        size: 'medium'
      }
    },
    large: {
      smallCard: {
        columnsCount: getColumnCount(cardList),
        size: 'large'
      }
    }
  };
  var _useContainerQuery = useContainerQuery(query, {}),
    _useContainerQuery2 = _slicedToArray(_useContainerQuery, 2),
    params = _useContainerQuery2[0],
    containerRef = _useContainerQuery2[1];
  var renderCards = function renderCards() {
    return cardList.map(function (card, key) {
      return /*#__PURE__*/_jsx(MastheadSmallCard, {
        className: styles.gridCard,
        wrapperClassName: cardList.length === 2 && styles.gridCardColumn,
        image: card.image,
        imageOnTop: card.imageOnTop,
        backgroundColor: card.backgroundColor,
        link: card.link,
        newWindow: card.newWindow,
        heading: card.heading,
        dropShadow: card.dropShadow,
        theme: card.theme,
        cardActionAttributes: card.cardActionAttributes
      }, key);
    });
  };
  var responsiveConfig = Responsive.getConfig(config.default, config, params);
  if (!responsiveConfig.smallCard || !_isObject(responsiveConfig.smallCard)) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }
  var columnCount = _isNumber(responsiveConfig.smallCard.columnsCount) ? responsiveConfig.smallCard.columnsCount : undefined;
  return /*#__PURE__*/_jsx("div", {
    ref: containerRef,
    children: /*#__PURE__*/_jsx(Grid, {
      columnsCount: columnCount,
      removeContainerGutter: true,
      gutter: "1vw",
      justify: gridAlignment,
      children: cardList && renderCards()
    })
  });
};